"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
class UnsupportedFilterExpressionValueType extends ExtendableError_1.default {
    constructor(fieldName, type) {
        super(`Invalid type: '${type}' for filter expression value '${fieldName}'`);
        this.fieldName = fieldName;
        this.type = type;
    }
}
exports.default = UnsupportedFilterExpressionValueType;
